import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"
import ApplicationService from "../../services/applications/Application.service"
import DataTable from "react-data-table-component"

let appService = null

const MessageHistoryItem = (props) => {
    const [paginationInfo, setpaginationInfo] = useState({
        per_page: 10,
        total: 0,
    })
    const [rowData, setrowData] = useState([])
    
    const columns = [
        {
          name: "NAME",
          selector: "name",
          sortable: true,
        },
        
        {
          name: "EMAIL",
          selector: "email",
          sortable: true,
        },
        {
          name: "PHONE",
          selector: "phone",
          sortable: true,
        },
        {
            name: "STATUS",
            selector: "status",
            sortable: true,
        },
        {
            name: "DATE",
            selector: "date",
            sortable: true,
        },
      ]

    useEffect(()=>{
        const userObj = JSON.parse(localStorage.getItem("authUser"))
        appService = new ApplicationService(userObj)
        const messageId = props.location.search.split("=")[1]
        fetchMessage(messageId, 0)
    }, [])

    const fetchMessage = async(id, page) => {
        const response =  await appService.getMessage(id, page)

        if (response.status) {
            // console.log("message details", response.data)
            setpaginationInfo({
                per_page: response.data.per_page,
                total: response.data.total,
              })
        
              const rws = response.data.data.map((item, index) => {
                return {
                  id: item.id,
                  name: item.name,
                  phone: item.telephone,
                  email: item.email,
                  date: new Date(item.updated_at).toLocaleString(),
                  status: item.status,
                }
              })
        
              setrowData(rws)
        }
    }

    return (
        <React.Fragment>
          <div className="page-content">
            <MetaTags>
              <title>Messaging</title>
            </MetaTags>
            <Container fluid>
              <div className="page-title-box">
                <Row className="align-items-center">
                  <Col md={8}>
                    <h6 className="page-title">Messaging</h6>
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item active">
                        Message Recipients
                      </li>
                    </ol>
                  </Col>
                </Row>
              </div>

              <DataTable
              title="Recipients"
              columns={columns}
              data={rowData}
              pagination
              highlightOnHover
              paginationServer
              paginationTotalRows={paginationInfo.total}
              paginationPerPage={paginationInfo.per_page}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              onChangePage={page => fetchMessage(page)}
            />
            
            </Container>
          </div>
        </React.Fragment>
      )
}

export default MessageHistoryItem